import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  tableWrapper: ({ spacing }) => css`
    margin-bottom: ${spacing.sm};
  `,

  containerDetails: ({ spacing }) => css`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(3, auto);
    gap: ${spacing.xxs};

    > div {
      line-height: 20px;
      width: 240px;
      height: 52px;
      gap: 4px;
    }
  `,

  boxContainer: ({ spacing }) => css`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: ${spacing.xxs};
  `,

  statusContainer: css`
    display: flex;
    flex-direction: column;
  `,

  titleWrapper: ({ spacing }) => css`
    margin: ${spacing.md} 0 ${spacing.xs} 0;
    line-height: ${spacing.sm};
  `,

  titleWrapperButton: css`
    display: flex;
    margin-top: 2px;
    justify-content: space-between;
    align-items: center;
  `,

  detailsAnchor: css`
    cursor: pointer;
  `,

  patientLink: ({ colors }) => css`
    color: ${colors.brand.primary[500]};
    cursor: pointer;
  `,

  paginationWrapper: ({ spacing }) => css`
    display: flex;
    margin: ${spacing.xs} 0;
  `,

  tooltip: ({ spacing }) => css`
    display: flex;
    gap: ${spacing.xxs};
  `,
})

export default useStyles
